require('../brokerStocksSaleOrderWizard.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

// @helpers
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @constants
const {
    FIRST_STEP,
    SECOND_STEP,
    DATE_FORMAT_ES,
    CHARGE_ACCOUNT_PREFIX
} = require('constants/index');

const CLASS_NAME = 'broker-stocks-sale-order-view';

class BrokerStocksSaleOrderSidebar extends React.Component {

    render () {
        const { immBrokerStocksSaleOrder } = this.props;
        const contractId = CHARGE_ACCOUNT_PREFIX + immBrokerStocksSaleOrder.getIn(['contract', 'product']) + immBrokerStocksSaleOrder.getIn(['contract', 'number']);
        const associatedAccountBalance = immBrokerStocksSaleOrder.getIn(['associatedAccount', 'balance']);
        const associatedAccountCurrency = immBrokerStocksSaleOrder.getIn(['associatedAccount', 'balance', 'currency']);
        const firstStepTitlesAmount = immBrokerStocksSaleOrder.getIn(['steps', FIRST_STEP, 'titlesAmount']);
        const language = getLanguage();
        const plainAmountObject = getPlainAmountObject(associatedAccountBalance);
        let titlesAmountInformation;

        // Only display titles amount in second step
        if (immBrokerStocksSaleOrder.get('visibleStep') == SECOND_STEP + 1) {
            if (firstStepTitlesAmount) {
                titlesAmountInformation = (
                    <div className={`${CLASS_NAME}__sidecolumn-information`}>
                        <h5 className={`${CLASS_NAME}__sidecolumn-information-title`}>
                            <FormattedText
                                value="stocksSaleOrder-titlesAmount"
                                injectedStrings={[associatedAccountCurrency]}
                                format="uppercase"
                            />
                        </h5>
                        <div className={`${CLASS_NAME}__sidecolumn-information-primary-text`}>
                            {firstStepTitlesAmount}
                        </div>
                    </div>
                );
            }
        }

        return (
            <OKSectionBox>
                <h4><FormattedText value="stocksSaleOrder-value" /></h4>

                <div className={`${CLASS_NAME}__sidecolumn-header`}>
                    <h3 className={`${CLASS_NAME}__sidecolumn-header-title`}>{immBrokerStocksSaleOrder.getIn(['operation', 'descriptionValue'])}</h3>
                </div>

                <div className={`${CLASS_NAME}__sidecolumn-information`}>
                    <h5 className={`${CLASS_NAME}__sidecolumn-information-title`}>
                        <FormattedText
                            value="stocksSaleOrder-contract"
                            format="uppercase"
                        />
                    </h5>
                    <div className={`${CLASS_NAME}__sidecolumn-information-primary-text`}>
                        {immBrokerStocksSaleOrder.get('walletAccountType')}
                    </div>
                    <div className={`${CLASS_NAME}__lighter-fg`}>
                        <FormattedText
                            value="stocksSaleOrder-contractNumber"
                            injectedStrings={[contractId]}
                        />
                    </div>
                </div>

                <div className={`${CLASS_NAME}__sidecolumn-information`}>
                    <h5 className={`${CLASS_NAME}__sidecolumn-information-title`}>
                        <FormattedText
                            value="stocksSaleOrder-owner"
                            format="uppercase"
                        />
                    </h5>
                    <div className={`${CLASS_NAME}__sidecolumn-information-primary-text`}>
                        {immBrokerStocksSaleOrder.get('owner')}
                    </div>
                    <div className={`${CLASS_NAME}__lighter-fg`}>
                        <FormattedText value="stocksSaleOrder-authorized" />
                    </div>
                </div>

                <div className={`${CLASS_NAME}__sidecolumn-information`}>
                    <h5 className={`${CLASS_NAME}__sidecolumn-information-title`}>
                        <FormattedText
                            value="stocksSaleOrder-associatedAccount"
                            format="uppercase"
                        />
                    </h5>
                    <div className={`${CLASS_NAME}__sidecolumn-information-primary-text`}>
                        {immBrokerStocksSaleOrder.getIn(['associatedAccount', 'number'])}
                    </div>
                    <div className={`${CLASS_NAME}__lighter-fg`}>
                        (
                        <FormattedText
                            value="stocksSaleOrder-associatedAccountBalance"
                        />
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                        />
                        )
                    </div>
                </div>
                
                <div className={`${CLASS_NAME}__sidecolumn-information`}>
                    <h5 className={`${CLASS_NAME}__sidecolumn-information-title`}>
                        <FormattedText
                            value="broker-rightsBuySidebarDeadlineLabel"
                            format="uppercase"
                        />
                    </h5>
                    <div className={`${CLASS_NAME}__sidecolumn-information-primary-text`}>
                        {DateHelper.buildFormattedDate(immBrokerStocksSaleOrder.getIn(['operation', 'endDate']), DATE_FORMAT_ES)}
                    </div>
                </div>

                {titlesAmountInformation}
            </OKSectionBox>
        );
    }
}

BrokerStocksSaleOrderSidebar.propTypes = {
    immBrokerStocksSaleOrder: PropTypes.object.isRequired,
};

module.exports = BrokerStocksSaleOrderSidebar;